import React, { PureComponent } from 'react';
import { all, assocPath, equals, find, path, pluck, propEq, values, pick } from 'ramda';
import PropTypes from 'prop-types';
import messages from './filterModalLocation.messages';
import { AccordionCheckbox } from '../../accordionCheckbox';

const subOptionsFieldName = 'regions';
const checkedFieldName = 'id';
const labelFieldName = 'name';

export class FilterModalLocation extends PureComponent {
  static propTypes = {
    setFilterDataByFilterName: PropTypes.func.isRequired,
    currentFilter: PropTypes.object.isRequired,
    locationData: PropTypes.arrayOf(PropTypes.object),
    setTouched: PropTypes.func.isRequired,
  };

  getSubOptionsValues = (value, name, subOptions = []) => {
    return subOptions.reduce((acc, subOption) => {
      if (!acc[subOption[checkedFieldName]]) {
        acc[subOption[checkedFieldName]] = {
          name,
          value,
        };
      }

      return acc;
    }, {});
  };

  areAllSubOptionsChecked = (optionsState, optionId, subOptionsFieldName) => {
    const subOptionsState = optionsState[optionId][subOptionsFieldName];
    const subOptionStateValues = pluck('value', values(subOptionsState));
    const subOptions = find(propEq(checkedFieldName, optionId), values(this.props.locationData))[subOptionsFieldName];

    return all(equals(true), subOptionStateValues) && subOptionStateValues.length === subOptions.length;
  };

  updateFiltersStateInStore = data => this.props.setFilterDataByFilterName(this.props.currentFilter.name, data);

  processChanges = updatedInputsState => {
    this.updateFiltersStateInStore(updatedInputsState);
    this.props.setTouched();
  };

  handleOptionCheckboxClick = (optionId, optionName) => {
    const value = !path([optionId, 'value'], this.props.currentFilter.data);
    const withValue = assocPath([optionId, 'value'], value, {});
    const withName = assocPath([optionId, labelFieldName], optionName, withValue);

    const updatedSubOptionStateValues = assocPath(
      [optionId, subOptionsFieldName],
      this.getSubOptionsValues(
        path([optionId, 'value'], withName),
        optionName,
        find(propEq(checkedFieldName, optionId), Object.values(this.props.locationData))[subOptionsFieldName]
      ),
      withName
    );

    this.processChanges(updatedSubOptionStateValues);
  };

  handleSubOptionCheckboxClick = (optionId, subOptionId, optionName) => {
    const value = !path([optionId, subOptionsFieldName, subOptionId, 'value'], this.props.currentFilter.data);

    const withValue = assocPath(
      [optionId, subOptionsFieldName, subOptionId, 'value'],
      value,
      this.props.currentFilter.data
    );

    const withName = assocPath([optionId, subOptionsFieldName, subOptionId, labelFieldName], optionName, withValue);

    const withParentValue = assocPath(
      [optionId, 'value'],
      this.areAllSubOptionsChecked(withName, optionId, subOptionsFieldName),
      withName
    );

    const withParentName = assocPath([optionId, labelFieldName], optionName, withParentValue);
    this.processChanges(pick([optionId], withParentName));
  };

  render() {
    return (
      <AccordionCheckbox
        subOptionsMarkedCountMessage={messages.regions}
        allSubOptionsMarkedMessage={messages.allRegions}
        inputsState={this.props.currentFilter.data}
        options={this.props.locationData}
        labelFieldName={labelFieldName}
        subOptionsFieldName={subOptionsFieldName}
        onOptionClick={this.handleOptionCheckboxClick}
        onSubOptionClick={this.handleSubOptionCheckboxClick}
      />
    );
  }
}
